import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import { navigate } from "vike/client/router"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import PubSub from "pubsub-js"

const AffiliateBanner = ({ banner }) => {
  return (
    <CMSRender
      contentType="PageSection"
      match={{ "content.name": banner }}
      renderItem={(data, id) => (
        <div className="w-full px-4 md:px-px1_l xl:px-px1_xl mb-[56px] lg:mb-[146px]">
          <div className="w-full max-w-[500px] md:max-w-[800px] lg:max-w-[900px] xl:max-w-w2_xl 2xl:max-w-w1_xl mx-auto">
          <Button
            variant="card_button_centered"
            key={id}
            onClick={() => PubSub.publish("open-contacts-partners")}
            // onClick={() => {
            //   navigate(data.menu[0].link[0].url)
            // }}
            className="max-w-w1_xl h-[104px] md:h-[154px] px-6 mx-auto"
          >
            <Typography
              variant="h3"
              className="text-center xl:!text-[48px] !text-primary group-hover:!text-white"
            >
              {data.menu[0].label}
            </Typography>
          </Button>
          </div>
        </div>
      )}
    />
  )
}

//The Aldoo Site Component definition
export const AldooComponent = {
  //the id that will be displayed in the admin
  id: "AffiliateBanner",
  //the component used to run the logic
  component: AffiliateBanner,
  //here we'll place the incoming data from the CMS
  input: {
    //this should be aligned with our cms fields?!
    banner: {
      type: "string",
      label: "Banner Name",
      description: "The name of the banner content to load from CMS",
      default: ""
    }
  },
  // Component metadata for admin interface
  meta: {
    name: "Affiliate Banner",
    description: "A clickable banner component that loads content from CMS",
    category: "Marketing"
  }
}


export default AffiliateBanner